export default "/_next/static/images/4575d728e38c11e193af08d738ad85a8.png";